import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnimateService {
	public scrollToTop(element, duration): void {
		this.scrollTo(this.getOffsetTop(element), duration);
	}

	private scrollTo(to, duration): void {
		if (duration <= 0) { return; }
		// IE compatibility
		const documentBody =
			document.documentElement && document.documentElement.scrollTop ? document.documentElement : document.body;
		const difference = to - documentBody.scrollTop;
		const perTick = difference / duration * 10;
		const self = this;
		setTimeout(function (): void {
			documentBody.scrollTop = documentBody.scrollTop + perTick;
			if (documentBody.scrollTop === to) { return; }
			self.scrollTo(to, duration - 10);
		}, 10);
	}

	private getOffsetTop(element): any {
		let totalOffset = element.offsetTop;
		while (element.offsetParent) {
			totalOffset += element.offsetParent.offsetTop;
			element = element.offsetParent;
		}
		return totalOffset;
	}
}
